/* eslint-disable no-unused-vars */
import React from 'react'
import { Container, Content, Title } from '../../../GlobalStyle'
import BoxShadow from '../../components/BoxShadowDiv'
import LineChart from '../Report1/chart'

import PieChart from './chart'
import { GridLayout } from './style'

const Report2 = () => {
  return (
    <Content>
      <Title>Relatório de margem de contribuição</Title>
      <GridLayout>
        <BoxShadow radius={'5px'} padding={'7px'} className="item3">
          <p>Top 5 produtos com maior margem</p>
          <PieChart series={'Valor'} data={[]} />
        </BoxShadow>

        <BoxShadow radius={'5px'} padding={'7px'} className={'item3'}>
          <p>Top 5 produtos com menor margem</p>
          <PieChart series={'Quantidade'} data={[]} />
        </BoxShadow>
        <BoxShadow radius={'5px'} padding={'7px'} className={'item3-1'}>
          <p>Índice de margem total</p>
          <PieChart series={'Quantidade'} data={[]} />
        </BoxShadow>
        <BoxShadow className={'item1'} radius={'5px'}>
          <Container>
            <LineChart passedData={[]} height={280} />
          </Container>
        </BoxShadow>
      </GridLayout>
    </Content>
  )
}

export default Report2
